const AUTH = Object.freeze({
  CERT: 1001000000, // 凭证
  CERT_CE: 1001010000, // 凭证-凭证录入
  CERT_CE_SAV: 1001010100, // 凭证-凭证录入-保存
  CERT_CE_SAV_TPL: 1001010200, // 凭证-凭证录入-保存模板
  CERT_CE_APL_TPL: 1001010300, // 凭证-凭证录入-调用模板
  CERT_CL: 1001020000, // 凭证-凭证列表
  CERT_CL_CRT: 1001020100, // 凭证-凭证列表-新增
  CERT_CL_CPY: 1001020200, // 凭证-凭证列表-复制
  CERT_CL_EDT: 1001020300, // 凭证-凭证列表-修改
  CERT_CL_REV: 1001020400, // 凭证-凭证列表-冲销
  CERT_CL_APR: 1001020500, // 凭证-凭证列表-审核
  CERT_CL_UAP: 1001020600, // 凭证-凭证列表-反审核
  CERT_CL_DEL: 1001020700, // 凭证-凭证列表-删除
  CERT_CL_SORT: 1001020800, // 凭证-凭证列表-整理
  CERT_CL_IMP: 1001020900, // 凭证-凭证列表-导入
  CERT_CL_EXP: 1001021000, // 凭证-凭证列表-导出
  CERT_CL_PRN: 1001021100, // 凭证-凭证列表-打印
  CERT_CSM: 1001030000, // 凭证-凭证汇总表
  CERT_CSM_EXP: 1001030100, // 凭证-凭证汇总表-导出
  CERT_BV: 1001040000, // 凭证-业务凭证
  CERT_BV_GV: 1001040100, // 凭证-业务凭证-生成凭证
  CERT_IV: 1001050000, // 凭证-进销存凭证
  CERT_IV_GV: 1001050100, // 凭证-进销存凭证-生成凭证
  CERT_BVN: 1001060000, // 凭证-业务凭证(New)
  CERT_BVN_GV: 1001060100, // 凭证-业务凭证(New)-生成凭证
  LDG: 1002000000, // 账簿
  LDG_DL: 1002010000, // 账簿-明细账
  LDG_DL_EXP: 1002010100, // 账簿-明细账-导出
  LDG_DL_PRN: 1002010200, // 账簿-明细账-打印
  LDG_GL: 1002020000, // 账簿-总账
  LDG_GL_EXP: 1002020100, // 账簿-总账-导出
  LDG_GL_PRN: 1002020200, // 账簿-总账-打印
  LDG_SB: 1002030000, // 账簿-科目余额表
  LDG_SB_EXP: 1002030100, // 账簿-科目余额表-导出
  LDG_SB_PRN: 1002030200, // 账簿-科目余额表-打印
  LDG_AP_DL: 1002040000, // 账簿-核算项目明细账
  LDG_AP_DL_EXP: 1002040100, // 账簿-核算项目明细账-导出
  LDG_AP_DL_PRN: 1002040200, // 账簿-核算项目明细账-打印
  LDG_AP_BAL: 1002050000, // 账簿-核算项目余额表
  LDG_AP_BAL_PRN: 1002050100, // 账簿-核算项目余额表-打印
  RPT: 1003000000, // 报表
  RPT_BS: 1003010000, // 报表-资产负债表
  RPT_BS_AF: 1003010100, // 报表-资产负债表-新增公式
  RPT_BS_DF: 1003010200, // 报表-资产负债表-删除公式
  RPT_BS_FR: 1003010300, // 报表-资产负债表-公式复位
  RPT_BS_EXP: 1003010400, // 报表-资产负债表-导出
  RPT_BS_PRN: 1003010500, // 报表-资产负债表-打印
  RPT_PS: 1003020000, // 报表-利润表
  RPT_PS_AF: 1003020100, // 报表-利润表-新增公式
  RPT_PS_DF: 1003020200, // 报表-利润表-删除公式
  RPT_PS_FR: 1003020300, // 报表-利润表-公式复位
  RPT_PS_EXP: 1003020400, // 报表-利润表-导出
  RPT_PS_PRN: 1003020500, // 报表-利润表-打印
  RPT_SPS: 1003030000, // 报表-门店利润表
  RPT_SPS_FR: 1003030100, // 报表-门店利润表-公式复位
  RPT_SPS_EXP: 1003030200, // 报表-门店利润表-导出
  RPT_SPS_PRN: 1003030300, // 报表-门店利润表-打印
  RPT_CFS: 1003040000, // 报表-现金流量表
  RPT_CFS_DTL: 1003040100, // 报表-现金流量表-明细
  RPT_CFS_RCP: 1003040200, // 报表-现金流量表-重算项目
  RPT_CFS_SLP: 1003040300, // 报表-现金流量表-选择项目
  RPT_CFS_EXP: 1003040400, // 报表-现金流量表-导出
  RPT_CFS_PRN: 1003040500, // 报表-现金流量表-打印
  RPT_CR: 1003050000, // 报表-自定义报表
  RPT_CR_CRT: 1003050100, // 报表-自定义报表-新增
  RPT_CR_EDT_PAGE: 1003050200, // 报表-自定义报表-编辑
  RPT_CR_DEL: 1003050300, // 报表-自定义报表-删除
  RPT_CR_AF: 1003050400, // 报表-自定义报表-新增公式
  RPT_CR_DF: 1003050500, // 报表-自定义报表-删除公式
  MRG_RPT: 1004000000, // 合并报表
  MRG_RPT_CBS: 1004010000, // 合并报表-综合资产负债表
  MRG_RPT_CBS_EXP: 1004010100, // 合并报表-综合资产负债表-导出
  MRG_RPT_CBS_PRN: 1004010200, // 合并报表-综合资产负债表-打印
  MRG_RPT_CPS: 1004020000, // 合并报表-综合利润表
  MRG_RPT_CPS_EXP: 1004020100, // 合并报表-综合利润表-导出
  MRG_RPT_CPS_PRN: 1004020200, // 合并报表-综合利润表-打印
  MRG_RPT_CCFS: 1004030000, // 合并报表-综合现金流量表
  MRG_RPT_CCFS_EXP: 1004030100, // 合并报表-综合现金流量表-导出
  MRG_RPT_CCFS_PRN: 1004030200, // 合并报表-综合现金流量表-打印
  FXD_AST: 1005000000, // 固定资产
  FXD_AST_FAM: 1005010000, // 固定资产-固定资产管理
  FXD_AST_FAM_CRT: 1005010100, // 固定资产-固定资产管理-新增
  FXD_AST_FAM_EDT: 1005010200, // 固定资产-固定资产管理-修改
  FXD_AST_FAM_DEL: 1005010300, // 固定资产-固定资产管理-删除
  FXD_AST_FAM_CHG: 1005010400, // 固定资产-固定资产管理-变动
  FXD_AST_FAM_CLN: 1005010500, // 固定资产-固定资产管理-清理
  FXD_AST_FAM_IMP: 1005010600, // 固定资产-固定资产管理-导入
  FXD_AST_FAM_EXP: 1005010700, // 固定资产-固定资产管理-导出
  FXD_AST_FAM_GV: 1005010800, // 固定资产-固定资产管理-生成凭证
  FXD_AST_FADS: 1005020000, // 固定资产-固定资产折旧统计
  FXD_AST_FADS_EXP: 1005020100, // 固定资产-固定资产折旧统计-导出
  FXD_AST_FADS_PRN: 1005020200, // 固定资产-固定资产折旧统计-打印
  FXD_AST_FADL: 1005030000, // 固定资产-固定资产明细账
  FXD_AST_FADL_EXP: 1005030100, // 固定资产-固定资产明细账-导出
  FXD_AST_FADL_PRN: 1005030200, // 固定资产-固定资产明细账-打印
  FXD_AST_FAC: 1005040000, // 固定资产-固定资产类别
  FXD_AST_FAC_CRT: 1005040100, // 固定资产-固定资产类别-新增
  FXD_AST_FAC_EDT: 1005040200, // 固定资产-固定资产类别-修改
  FXD_AST_FAC_DEL: 1005040300, // 固定资产-固定资产类别-删除
  LTDE: 1006000000, // 长期待摊
  LTDE_AEM: 1006010000, // 长期待摊-摊销费用管理
  LTDE_AEM_CRT: 1006010100, // 长期待摊-摊销费用管理-新增
  LTDE_AEM_EDT: 1006010200, // 长期待摊-摊销费用管理-修改
  LTDE_AEM_DEL: 1006010300, // 长期待摊-摊销费用管理-删除
  LTDE_AEM_CHG: 1006010400, // 长期待摊-摊销费用管理-变动
  LTDE_AEM_CLN: 1006010500, // 长期待摊-摊销费用管理-清理
  LTDE_AEM_IMP: 1006010600, // 长期待摊-摊销费用管理-导入
  LTDE_AEM_EXP: 1006010700, // 长期待摊-摊销费用管理-导出
  LTDE_AEM_GV: 1006010800, // 长期待摊-摊销费用管理-生成凭证
  LTDE_AEM_DV: 1006010900, // 长期待摊-摊销费用管理-删除凭证
  LTDE_QG: 1006020000, // 长期待摊-快速生成
  LTDE_QG_QK_GEN: 1006020100, // 长期待摊-快速生成-快速生成
  LTDE_QG_QR: 1006020200, // 长期待摊-快速生成-快速冲销
  STL: 1007000000, // 结账
  STL_STL: 1007010000, // 结账-结账
  STL_STL_STL: 1007010100, // 结账-结账-结账
  STL_STL_UST: 1007010200, // 结账-结账-反结账
  STL_STL_TST_AMT: 1007010300, // 结账-结账-测试金额
  STL_STL_SET: 1007010400, // 结账-结账-设置
  STL_STL_GV: 1007010500, // 结账-结账-生成凭证
  CSH: 1008000000, // 出纳
  CSH_JNL: 1008010000, // 出纳-日记账
  CSH_JNL_CRT: 1008010100, // 出纳-日记账-新增
  CSH_JNL_EDT: 1008010200, // 出纳-日记账-修改
  CSH_JNL_DEL: 1008010300, // 出纳-日记账-删除
  CSH_JNL_IMP: 1008010400, // 出纳-日记账-导入
  CSH_JNL_EXP: 1008010500, // 出纳-日记账-导出
  CSH_JNL_GV: 1008010600, // 出纳-日记账-生成凭证
  CSH_JNL_DV: 1008010700, // 出纳-日记账-删除凭证
  CSH_REC_GL: 1008020000, // 出纳-核对总账
  CSH_ACC: 1008030000, // 出纳-账户
  CSH_ACC_CRT: 1008030100, // 出纳-账户-新增
  CSH_ACC_EDT: 1008030200, // 出纳-账户-修改
  CSH_ACC_DEL: 1008030300, // 出纳-账户-删除
  CSH_ACC_US: 1008030400, // 出纳-账户-修改状态
  CSH_QG: 1008040000, // 出纳-快速生成
  CSH_QG_QK_GEN: 1008040100, // 出纳-快速生成-快速生成
  CSH_FSS: 1008050000, // 出纳-资金结算表
  CSH_FSS_EDT: 1008050100, // 出纳-资金结算表-编辑
  CSH_FSS_FRE: 1008050200, // 出纳-资金结算表-结存
  CSH_FSS_PRN: 1008050200, // 出纳-资金结算表-打印
  SET: 1009000000, // 设置
  SET_SUB: 1009010000, // 设置-科目
  SET_SUB_CRT: 1009010100, // 设置-科目-新增
  SET_SUB_EDT: 1009010200, // 设置-科目-修改
  SET_SUB_DEL: 1009010300, // 设置-科目-删除
  SET_SUB_US: 1009010400, // 设置-科目-修改状态
  SET_SUB_IMP: 1009010500, // 设置-科目-导入
  SET_SUB_EXP: 1009010600, // 设置-科目-导出
  SET_AA: 1009020000, // 设置-辅助核算
  SET_AA_CRT: 1009020100, // 设置-辅助核算-新增
  SET_AA_EDT: 1009020200, // 设置-辅助核算-修改
  SET_AA_DEL: 1009020300, // 设置-辅助核算-删除
  SET_AA_US: 1009020400, // 设置-辅助核算-修改状态
  SET_AA_SYN: 1009020500, // 设置-辅助核算-同步
  SET_AA_IMP: 1009020600, // 设置-辅助核算-导入
  SET_AA_EXP: 1009020700, // 设置-辅助核算-导出
  SET_BSM: 1009030000, // 设置-业务科目对照表
  SET_BSM_EDT: 1009030100, // 设置-业务科目对照表-修改
  SET_SLS: 1009040000, // 设置-科目关联设置
  SET_SLS_SAV: 1009040100, // 设置-科目关联设置-保存
  SET_SLS_SSB: 1009040200, // 设置-科目关联设置-设置科目
  SET_CT: 1009050000, // 设置-凭证模板
  SET_CT_CRT: 1009050100, // 设置-凭证模板-新增
  SET_CT_EDT: 1009050200, // 设置-凭证模板-修改
  SET_CT_DEL: 1009050300, // 设置-凭证模板-删除
  SET_CT_US: 1009050400, // 设置-凭证模板-修改状态
  SET_CT_SD: 1009050500, // 设置-凭证模板-设置默认
  SET_CT_IMP: 1009050600, // 设置-凭证模板-导入
  SET_FIB: 1009060000, // 设置-财务初始余额
  SET_FIB_SAV: 1009060100, // 设置-财务初始余额-保存
  SET_FIB_IMP: 1009060200, // 设置-财务初始余额-导入
  SET_FIB_EXP: 1009060300, // 设置-财务初始余额-导出
  SET_FIB_TB: 1009060400, // 设置-财务初始余额-试算平衡
  SET_LNK_INVENTORY: 1009070000, // 设置-关联进销存
  SET_LNK_INVENTORY_MOD: 1009070100, // 设置-关联进销存-变更
  SET_SYSP: 1009080000, // 设置-系统参数
  SET_SYSP_SAV: 1009080100, // 设置-系统参数-保存
  SET_SYSP_FRB: 1009080200 // 设置-系统参数-财务重建
});

export default AUTH;
